<template>
  <div class="management-insight-card">
    <header class="management-insight-card-header">
      <h3 class="header-title">{{ header }}</h3>
    </header>
    <b-row style="margin-top: 5px" class="parent-overlay">
      <p class="management-text" @scroll="scrollManagementText">
        The Data Management Dashboard is a compilation of metrics that provides insights into data compliance, data changes, and query performance. If your Data Performance Score has increased since last week, this means you have reduced the amount of data changes and queries while continuing to improve participant compliance. Great job! If your Data Performance Score has decreased, please read
        below for more insights into how you can improve your score.
        <br /><br />
        One metric that could be affecting data quality is open queries (if enabled for your study). To see if this is an issue, review the "Top 5 Queries" chart to see if any one activity is generating the majority of queries. You can also look at the "Query Status" chart, which showcases queries that have been open for a long period of time. Once about 50% of your study data is in, you will want
        to see a downward trend on the "Data Queries" chart.
        <br /><br />
        Missing data is represented in the "Overall Data Collection with Completion Metrics" chart. This KPI includes all activities captured within the THREAD Platform for your study, which may include eConsents, ePROs, surveys, EDCs, comprehension quizzes, sensor data, and participant tasks. When viewing this chart, you can compare sites or participants to see if there are striking differences
        in the amount of missing vs. completed data.
        <br /><br />
        In the "Time to Activity Status" chart, take note of an individual Site's time to Entry Completed and Approved compared to other Sites. The "Form Status" chart should start out with most forms in the Entry Completed and Approved statuses. By the end of the study, they should be in the Verified and Signed Off statuses.
        <br /><br />
        This entire dashboard can be filtered by Countries, Sites, or Participants. The date can also be adjusted to see only participants that enrolled within a specific time period.
      </p>
      <div class="gradient-overlay" v-if="!isScrolledToBottom"></div>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    score: { type: [Number, String], default: 0 },
    insights: { type: String, default: "" },
    header: { type: String, default: "DATA MANAGEMENT INSIGHTS" },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      isScrolledToBottom: false
    };
  },
  methods: {
    scrollManagementText(e) {
      if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
        this.isScrolledToBottom = true;
      } else {
        this.isScrolledToBottom = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.management-insight-card {
  display: flex;
  flex-flow: column wrap;
  min-width: 350px;

  .management-insight-card-header {
    margin: 0 0 8px;

    .header-title {
      margin: 0;
      font-family: "Roboto-Medium";
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
    }
  }

  .management-text {
    position: relative;
    font-family: "Roboto-Light";
    font-size: 16px;
    height: 114px;
    background-color: #10284b;
    padding: 5px;
    cursor: default;

    overflow-y: scroll;
    scrollbar-color: #b0bac9 transparent;
    /* thumb and track color */
    scrollbar-width: 7px;

    &::-webkit-scrollbar {
      width: 7px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  .parent-overlay {
    position: relative;

    .gradient-overlay {
      display: block;
      position: absolute;
      height: calc(156px / 2);
      width: 100%;
      bottom: 0;
      left: 0;
      background: rgb(36, 62, 100);
      background: linear-gradient(180deg, rgba(36, 62, 100, 0) 0%, rgba(36, 62, 100, 1) 100%);
      z-index: 100;
      pointer-events: none;
    }
  }
}
</style>
